// extracted by mini-css-extract-plugin
export var content = "index-module--content--US2f7";
export var customerProfile = "index-module--customerProfile--oiy6C";